/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getTrustedPersonInfos = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Trusted Person Info query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-trusted-person-info/get?${queryString}`);
};

export const getTrustedPersonInfoByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-trusted-person-info/${id}`);
};

export const getTrustedPersonInfoByMID = (mid) => {
  return API.get(`${getApiUrl()}/api/tkt1-trusted-person-info/mid/${mid}`);
};

export const createTrustedPersonInfo = (trustedPersonInfoData) => {
  return API.post(`${getApiUrl()}/api/tkt1-trusted-person-info/`, trustedPersonInfoData);
};

export const updateTrustedPersonInfo = (id, trustedPersonInfoData) => {
  return API.put(`${getApiUrl()}/api/tkt1-trusted-person-info/${id}`, trustedPersonInfoData);
};

export const deleteTrustedPersonInfo = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-trusted-person-info/${id}`);
};

export const tkt1TrustedPersonService = {
  getTrustedPersonInfos,
  getTrustedPersonInfoByID,
  getTrustedPersonInfoByMID,
  createTrustedPersonInfo,
  updateTrustedPersonInfo,
  deleteTrustedPersonInfo
};